<template>
  <div class="Benefit">
    <img class="Benefit__img" :src="img"/>
    <h3 class="Benefit__title">{{ title }}</h3>
    <p class="Benefit__text">{{ text }}</p>
  </div>
</template>
<script>
export default {
  name: 'Benefits',
  props: {
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    img: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="scss">
.Benefit {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 32px;
  width: 367px;
  height: 376px;
  background: #FFFFFF;
  border: 1px solid #F2F2F2;
  box-sizing: border-box;
  box-shadow: 0 15px 30px -10px rgba(21, 17, 71, 0.03);
  border-radius: 24px;
  color: $color;
  margin: 9px;
  &__img {
    width: 54px;
  }
  &__title {
    font-weight: 600;
    font-size: 24px;
    line-height: 150%;
    margin: 16px 0;
  }
  &__text {
    font-size: 18px;
    line-height: 150%;
  }
  @media screen and (max-width: 775px) {
    margin: 13px 0;
    width: 100%;
    height: auto;
  }
}
</style>
